import { render, staticRenderFns } from "./RequestTradeMapModal.vue?vue&type=template&id=23211769&scoped=true&"
import script from "./RequestTradeMapModal.vue?vue&type=script&lang=ts&"
export * from "./RequestTradeMapModal.vue?vue&type=script&lang=ts&"
import style0 from "./RequestTradeMapModal.vue?vue&type=style&index=0&id=23211769&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23211769",
  null
  
)

export default component.exports